/**
 * Format a number as Ukrainian currency (UAH)
 * @param amount - The amount to format
 * @returns Formatted string with comma thousand separators
 * @example formatSalary(45000) // "45,000"
 */
export function formatSalary(amount: number): string {
  return new Intl.NumberFormat('en-US').format(amount)
}

/**
 * Format a salary range
 * @param min - Minimum salary
 * @param max - Maximum salary
 * @returns Formatted salary range string
 * @example formatSalaryRange(40000, 90000) // "₴40,000 - 90,000"
 */
export function formatSalaryRange(min?: number | null, max?: number | null): string | null {
  if (!min && !max) return null

  const parts: string[] = []

  if (min) parts.push(formatSalary(min))
  if (min && max) parts.push('-')
  if (max) parts.push(formatSalary(max))

  return `₴${parts.join(' ')}`
}
